import { GRAPHQL_SERVER_ENV, CMX_ENV } from '../environments';
import { buildGraphqlServerUri } from './buildGraphqlServerUri';
import { buildCmxServiceUri } from './buildCmxServiceUri';
import { buildCompanyListUri } from './buildCompanyListUri';
import { buildLocaleListUri } from './buildLocaleListUri';
import { buildAwsUri } from './buildAwsUri';
import { buildCloudFrontUri } from './buildCloudFrontUri';
import { buildIdServiceUri } from './buildIdServiceUri';

export * from './utils';

export const ID_SERVICE_URI = buildIdServiceUri( GRAPHQL_SERVER_ENV );
export const GRAPHQL_SERVER_URI = buildGraphqlServerUri( GRAPHQL_SERVER_ENV );
export const CLOUDFRONT_URI = buildCloudFrontUri( GRAPHQL_SERVER_ENV );
export const COMPANY_LIST_URI = buildCompanyListUri( GRAPHQL_SERVER_ENV );
export const CMX_SERVICE_URI = buildCmxServiceUri( CMX_ENV );
export const LOCALE_LIST_URI = buildLocaleListUri( CMX_ENV );
export const AWS_URI = buildAwsUri( GRAPHQL_SERVER_ENV );
